import React from "react";

export default function ExamPanel({
  title = "Mock Test",
  eyebrow,
  questionLabel,
  meta,
  instructions,
  media,
  children,
  footer,
}) {
  const instructionLines = Array.isArray(instructions)
    ? instructions
    : instructions
      ? [instructions]
      : [];

  return (
    <section className="min-h-[calc(100vh-230px)] overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm">
      <div className="h-1.5 bg-violet-600" />

      <div className="p-4 sm:p-6 lg:p-8">
        <div className="grid gap-5 border-b border-slate-100 pb-5 lg:grid-cols-[minmax(0,1fr),auto] lg:items-start">
          <div className="min-w-0">
            {eyebrow && (
              <p className="text-sm font-bold uppercase tracking-wide text-violet-700">
                {eyebrow}
              </p>
            )}
            <h2 className="mt-1 text-2xl font-extrabold text-gray-900 sm:text-3xl">
              {title}
            </h2>
            {instructionLines.length > 0 && (
              <div className="mt-4 max-w-5xl space-y-2 text-sm leading-6 text-gray-600 sm:text-base">
                {instructionLines.map((line, index) => (
                  <p key={`${line}-${index}`}>{line}</p>
                ))}
              </div>
            )}
          </div>

          <div className="flex shrink-0 flex-col items-start gap-2 lg:items-end lg:justify-self-end">
            {questionLabel && (
              <span className="inline-flex min-h-9 min-w-[9.5rem] items-center justify-center rounded-md bg-violet-50 px-3 py-2 text-center text-sm font-bold text-violet-800 ring-1 ring-violet-100">
                {questionLabel}
              </span>
            )}
            {meta && (
              <span className="inline-flex min-h-9 min-w-[9.5rem] items-center justify-center rounded-md bg-slate-50 px-3 py-2 text-center text-sm font-bold text-gray-700 ring-1 ring-slate-200">
                {meta}
              </span>
            )}
            {media && (
              <div className="rounded-md bg-slate-50 p-3 ring-1 ring-slate-100">
                {media}
              </div>
            )}
          </div>
        </div>

        <div className="mt-6">{children}</div>

        {footer && (
          <div className="mt-6 rounded-md bg-slate-50 p-4 text-sm text-gray-600 ring-1 ring-slate-100">
            {footer}
          </div>
        )}
      </div>
    </section>
  );
}
